// extracted by mini-css-extract-plugin
module.exports =  {"collapse":"qoLwHKDZBcZhyBf91hDv","content":"m640YETRgBcCWCpn7ul0","placeCard":"XLXc6qUb3BIZz5ULuq3w"};